import ContentContainer from "Components/Container/ContentContainer";
import { BackButton, Button, Input } from "Components/CustomComponents";
import React, { useEffect } from "react";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import { Controller, FieldValues, useForm } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
// import { useParams } from "react-router-dom";
import { ErrorToast, SuccessToast } from "Hooks/useToast";
import styles from "./AddDriver.module.scss";
import { useCreateDriverMutation } from "Data/services/driversApi";
import { getErrorMessage } from "Hooks/useErrorHandler";
import { WEB_ROUTES } from "../../constants";
import { useNavigate } from "react-router-dom";

export interface DriverFormData {
  firstname: string;
  lastname: string;
  username: string;
  mobile_no: string;
  password: string;
  confirm_password: string;
  truck_no: string;
  image_url?: string | null | undefined;
}

const AddDriver: React.FC = () => {
  const {
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm<DriverFormData>({
    mode: "onChange",
    defaultValues: {
      firstname: "",
      lastname: "",
      username: "",
      mobile_no: "",
      password: "",
      confirm_password: "",
      truck_no: "",
    },
  });

  const Password = watch("password");
  const ConfirmPassword = watch("confirm_password");

  const navigate = useNavigate();

  useEffect(() => {
    if (errors.firstname?.message) {
      ErrorToast(errors.firstname.message as string);
    }
    if (errors.lastname?.message) {
      ErrorToast(errors.lastname.message as string);
    }
    if (errors.username?.message) {
      ErrorToast(errors.username.message as string);
    }
    if (errors.mobile_no?.message) {
      ErrorToast(errors.mobile_no.message as string);
    }
    if (errors.password?.message) {
      ErrorToast(errors.password.message as string);
    }
    if (errors.confirm_password?.message) {
      ErrorToast(errors.confirm_password.message as string);
    }
    if (errors.truck_no?.message) {
      ErrorToast(errors.truck_no.message as string);
    }
  }, [
    errors.firstname?.message,
    errors.lastname?.message,
    errors.username?.message,
    errors.mobile_no?.message,
    errors.password?.message,
    errors.confirm_password?.message,
    errors.truck_no?.message,
  ]);

  const [createDriver, { isLoading }] = useCreateDriverMutation();

  const handleCreateDriver = async (data: DriverFormData | FieldValues) => {
    // console.log("handleCreateDriver");
    // console.log(data);
    try {
      const response = await createDriver(data).unwrap();
      if (response.code === 200) {
        SuccessToast(response.message);
        navigate(WEB_ROUTES.DRIVERS);
      }
    } catch (error: unknown) {
      // console.log("Add Driver Error:", error);
      ErrorToast(getErrorMessage(error));
    }
  };

  return (
    <div className={styles.AddDriver}>
      <BackButton isRelative={true} text="Add Driver" classes="mb-1" />

      <ContentContainer
        bg="#ffffff"
        classes="d-flex justify-content-center p-4"
        style={{ borderRadius: "12px" }}
        hasBoxShadow={true}
      >
        <div className={`${styles.profileCard}`}>
          <Form onSubmit={handleSubmit(handleCreateDriver)}>
            {/* <div className="d-flex justify-content-center w-100 mb-5">
              <div className="position-relative mt-5 mt-sm-0">
                <img
                  alt=""
                  src="../images/user_image.png"
                  width={"150px"}
                  height={"150px"}
                  className={`${styles.profileImage} rounded-circle`}
                />
                <div className={`${styles.cameraBtn} rounded-circle `}>
                  <CameraIcon />
                </div>
              </div>
            </div> */}

            <Row className="gap-3 gap-md-0">
              <Col sm={12} md={6}>
                <Controller
                  control={control}
                  name="firstname"
                  rules={{
                    required: "First name is required.",
                  }}
                  render={({ field: { onChange, value } }) => (
                    <Input
                      classes={`border-0`}
                      placeholder="First Name"
                      type="text"
                      value={value}
                      onChange={onChange}
                    />
                  )}
                />
              </Col>
              <Col sm={12} md={6}>
                <Controller
                  control={control}
                  name="lastname"
                  rules={{
                    required: "Last name is required.",
                  }}
                  render={({ field: { onChange, value } }) => (
                    <Input
                      classes={`border-0`}
                      placeholder="last Name"
                      type="text"
                      value={value}
                      onChange={onChange}
                    />
                  )}
                />
              </Col>
            </Row>

            <Controller
              control={control}
              name="mobile_no"
              rules={{
                required: "Phone is required.",
              }}
              render={({ field: { onChange, value } }) => (
                <PhoneInput
                  inputClass={`border-0`}
                  placeholder="Phone Number"
                  country={"us"}
                  value={value}
                  onChange={(phone) => onChange(phone)}
                />
              )}
            />

            <Controller
              control={control}
              name="username"
              rules={{
                required: "User name is required.",
              }}
              render={({ field: { onChange, value } }) => (
                <Input
                  classes={`border-0 my-3`}
                  placeholder="User Name"
                  type="text"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            <Controller
              control={control}
              name="password"
              rules={{
                required: "Password is required.",
              }}
              render={({ field: { onChange, value } }) => (
                <Input
                  classes={`border-0 my-3`}
                  placeholder="Password"
                  type="text"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            <Controller
              control={control}
              name="confirm_password"
              rules={{
                required: "Confirm Password is required.",
                validate: (value) => {
                  // console.log(value);
                  console.log(ConfirmPassword);

                  if (value !== Password) {
                    return "Password must be match with confirm password.";
                  }
                },
              }}
              render={({ field: { onChange, value } }) => (
                <Input
                  classes={`border-0 my-3`}
                  placeholder="Confirm Password"
                  type="text"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
            <Controller
              control={control}
              name="truck_no"
              rules={{
                required: "Truck no. is required.",
              }}
              render={({ field: { onChange, value } }) => (
                <Input
                  classes={`border-0 my-3`}
                  placeholder="Truck no"
                  type="text"
                  value={value}
                  onChange={onChange}
                />
              )}
            />

            <Row>
              <Col sm={12} md={12}>
                <Button
                  className="blackBg"
                  type={"submit"}
                  text={
                    isLoading ? (
                      <Spinner animation="border" variant="light" size="sm" />
                    ) : (
                      "Save"
                    )
                  }
                />
              </Col>
            </Row>
          </Form>
        </div>
      </ContentContainer>
    </div>
  );
};

export default AddDriver;
